import React from 'react';

export const YouTube = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 23 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.06 0l.189.005A3.44 3.44 0 0122.5 3.44v9.12l-.005.189A3.44 3.44 0 0119.06 16H3.44l-.189-.005A3.44 3.44 0 010 12.56V3.44l.005-.189A3.44 3.44 0 013.44 0h15.62zM8.75 3.28v8.66l6.77-4.33-6.77-4.33z"
      fillRule="evenodd"
    />
  </svg>
);

export default YouTube;
